import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ChevronDown } from "lucide-react";
import { Logo } from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { NotificationBell } from "@/components/NotificationBell";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { label: "Community", to: "/community" },
  { label: "Find a company", to: "/companies" },
  { label: "Properties", to: "/properties" },
  { label: "Post a job", to: "/post-a-job" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/");
  };

  return (
    <header className="sticky top-0 z-50 bg-[#FAFAF7]/95 backdrop-blur-sm border-b border-[#E3E8E8]" data-testid="site-header">
      <div className="propora-container flex items-center justify-between h-[72px]">
        <Link to="/" data-testid="header-home-link">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {NAV.map((n) => (
            <Link
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.to.replace("/", "")}`}
              className="text-[15px] font-medium text-[#0B1733] hover:text-[#007F83] transition-colors"
            >
              {n.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <>
              <NotificationBell />
              <Link to={user.role === "admin" ? "/admin" : "/dashboard"} data-testid="header-dashboard-link">
                <Button variant="ghost" className="text-[#0B1733] hover:text-[#007F83] hover:bg-[#E8F5F1]">
                  {user.role === "admin" ? "Admin" : "Dashboard"}
                </Button>
              </Link>
              <Button onClick={handleLogout} data-testid="header-logout-btn" variant="outline" className="rounded-full border-[#E3E8E8]">
                Log out
              </Button>
            </>
          ) : (
            <>
              <Link to="/login" data-testid="header-login-link">
                <Button variant="ghost" className="text-[#0B1733] hover:text-[#007F83] hover:bg-transparent">Log in</Button>
              </Link>
              <Link to="/register" data-testid="header-join-link">
                <Button className="rounded-full bg-[#007F83] hover:bg-[#006B70] text-white px-6">Join free</Button>
              </Link>
            </>
          )}
        </div>

        <button className="lg:hidden text-[#0B1733]" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#FAFAF7] border-t border-[#E3E8E8] px-5 py-4 space-y-1" data-testid="mobile-menu">
          {NAV.map((n) => (
            <Link key={n.to} to={n.to} onClick={() => setOpen(false)} className="block py-3 text-[#0B1733] font-medium border-b border-[#E3E8E8]/60">
              {n.label}
            </Link>
          ))}
          <div className="pt-3 flex flex-col gap-2">
            {user ? (
              <>
                <Link to={user.role === "admin" ? "/admin" : "/dashboard"} onClick={() => setOpen(false)}>
                  <Button variant="outline" className="w-full rounded-full">{user.role === "admin" ? "Admin" : "Dashboard"}</Button>
                </Link>
                <Button onClick={handleLogout} variant="ghost" className="w-full">Log out</Button>
              </>
            ) : (
              <>
                <Link to="/login" onClick={() => setOpen(false)}><Button variant="outline" className="w-full rounded-full">Log in</Button></Link>
                <Link to="/register" onClick={() => setOpen(false)}><Button className="w-full rounded-full bg-[#007F83] hover:bg-[#006B70] text-white">Join free</Button></Link>
              </>
            )}
          </div>
        </div>
      )}
    </header>
  );
};
